import { data } from "autoprefixer";
import {
  LOGIN_SUCCESS,
  APPROVED_SUPPLIERS,
  UNAPPROVED_SUPPLIERS,
  FETCH_ADMIN_STATS,
  APPROVED_CUSTOMERS,
  UNAPPROVED_CUSTOMERS,
  FETCH_PRODUCTS,
  BASE_CURRENCY,
  FETCH_CURRENCIES,
  FETCH_COUNTRIES,
  ADD_CURRENCY,
  FETCH_CATEGORIES,
  ADD_PRODUCT,
  FETCH_APPROVED_SUPPLIER,
  FETCH_UNAPPROVED_SUPPLIER,
  FETCH_SETTINGS,
  GET_CUSTOMER,
  GET_UNAPPROVED_CUSTOMER,
  UPDATE_UNAPPROVED_CUSTOMER,
  ADD_CATEGORY,
  DELETE_APPROVED_SUPPLIER,
  DELETE_APPROVED_CUSTOMER,
  PAUSE_SUPPLIER_SIGNUP,
  RESUME_SUPPLIER_SIGNUP,
  PAUSE_USER_SIGNUP,
  RESUME_USER_SIGNUP,
  LOGOUT,
  ADD_SUPPLIER,
  ADD_CUSTOMER,
  TOKEN,
  UPDATE_SUPPLIER,
  UPDATE_UNAPPROVED_SUPPLIER,
  UPDATE_SUPPLIER_LICENCE,
  UPDATE_UNAPPROVED_SUPPLIER_LICENCE,
  UPDATE_PRODUCT,
  UPDATE_ADMIN_USERNAME,
  UPDATE_CUSTOMER_LICENCE,
  UPDATE_CUSTOMER,
  DELETE_PRODUCT,
  DELETE_UNAPPROVED_SUPPLIER,
  DELETE_UNAPPROVED_CUSTOMER,
  FETCH_ORDERS,
  FETCH_TRANSACTIONS,
  FETCH_SELECTED_SUPPLIERS,
  FETCH_ORDER,
  PAUSE_SUPPLIER_CALL_REQUEST,
  RESUME_SUPPLIER_CALL_REQUEST,
  PAUSE_CUSTOMER_CALL_REQUEST,
  RESUME_CUSTOMER_CALL_REQUEST,
  CALL_SUPPLIER_REQUESTS,
  CALL_USER_REQUESTS,
  FETCH_SUPPLIER_FAQ,
  FETCH_CUSTOMER_FAQ,
  CREATE_SUPPLIER_FAQ,
  CREATE_USER_FAQ,
  UPDATE_USER_FAQ,
  UPDATE_SUPPLIER_FAQ,
  DELETE_SUPPLIER_FAQ,
  DELETE_USER_FAQ,
  DELETE_CALL_SUPPLIER_REQUEST,
  DELETE_CALL_USER_REQUEST,
  UPDATE_MULTIPLE_APPROVED_SUPPLIERS,
  UPDATE_MULTIPLE_CUSTOMERS,
  UPDATE_MULTIPLE_UNAPPROVED_CUSTOMERS,
  UPDATE_MULTIPLE_UNAPPROVED_SUPPLIERS,
  FETCH_ORDERS_BY_SUPPLIER,
  FETCH_SUPPLIER_PAYMENTS,
  FETCH_SUPPLIER_PRODUCTS,
  FETCH_SUPPLIER_REPORTS,
  UPDATE_SUPPLIER_PAYMENTS,
  REFUND,
  RESET_EMAIL,
  RESET_CODE,
  RESTORE_USER_ACCOUNT,
  RESTORE_SUPPLIER_ACCOUNT,
  DELETED_SUPPLIERS,
  DELETED_USERS,
} from "../actions/types";

const initialState = {
  isLoggedIn: false,
  currentAdmin: {},
  stats: {},
  suppliers: {},
  customers: {},
  products: [],
  baseCurrency: {},
  currencies: [],
  countries: [],
  categories: [],
  supplier: {},
  settings: {},
  customer: {},
  orders: [],
  order: {},
  selectedSuppliers: [],
  transactions: [],
  supplierSignup: true,
  userSignup: true,
  supplierCallRequest: true,
  customerCallRequest: true,
  callRequests: {
    supplier: [],
    user: [],
  },
  faqs: {
    supplier: [],
    customer: [],
  },
  token: "",
  reset_email: "",
  reset_code: "",
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        currentAdmin: action.payload,
      };

    case TOKEN:
      return {
        ...state,
        token: action.payload,
      };

    case RESET_EMAIL:
      return {
        ...state,
        reset_email: action.payload,
      };

    case RESET_CODE:
      return {
        ...state,
        reset_code: action.payload,
      };

    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        currentAdmin: {},
        token: "",
      };

    case FETCH_ADMIN_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    case APPROVED_SUPPLIERS:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          approved: action.payload,
        },
      };

    case UNAPPROVED_SUPPLIERS:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          unapproved: action.payload,
        },
      };

    case DELETED_SUPPLIERS:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          deleted: action.payload,
        },
      };

    case DELETED_USERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          deleted: action.payload,
        },
      };

    case APPROVED_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          approved: action.payload,
        },
      };

    case UNAPPROVED_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          unapproved: action.payload,
        },
      };

    case FETCH_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      };

    case BASE_CURRENCY:
      return {
        ...state,
        baseCurrency: action.payload,
      };

    case FETCH_CURRENCIES:
      return {
        ...state,
        currencies: action.payload,
      };

    case FETCH_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
      };

    case ADD_CURRENCY:
      return {
        ...state,
        currencies: action.payload,
      };

    case ADD_PRODUCT:
      return {
        ...state,
        products: [...state.products, action.payload],
      };

    case DELETE_PRODUCT:
      return {
        ...state,
        products: {
          ...state.products.data,
          data: state.products.data.filter(
            (product) => !action.payload.find((item) => item === product.id)
          ),
        },
      };

    case UPDATE_PRODUCT:
      let updatedProduct = state.products.data.map((item) => {
        const selected = item.id === action.payload.id ? action.payload : item;
        return selected
          ? {
              ...item,
              ...selected,
            }
          : item;
      });
      return {
        ...state,
        products: {
          ...state.products.data,
          data: updatedProduct,
        },
      };

    case FETCH_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      };

    case FETCH_SETTINGS:
      return {
        ...state,
        settings: action.payload[0],
      };

    case FETCH_APPROVED_SUPPLIER:
      return {
        ...state,
        supplier: state.suppliers.approved.data.find(
          (i) => i.id === action.payload
        ),
      };

    case FETCH_UNAPPROVED_SUPPLIER:
      return {
        ...state,
        supplier: state.suppliers.unapproved.data.find(
          (i) => i.id === action.payload
        ),
      };

    case UPDATE_SUPPLIER:
      let updated_supplier = state.suppliers.approved.data.map((user) => {
        return action.payload?.id === user.id
          ? {
              ...user,
              ...action.payload,
            }
          : user;
      });
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          approved: {
            ...state.suppliers.approved,
            data: updated_supplier,
          },
        },
      };

    case UPDATE_MULTIPLE_APPROVED_SUPPLIERS:
      let updatedSupplier = state.suppliers.approved.data.map((user) => {
        let selected = action.payload.find(
          (supplier) => supplier.id === user.id
        );

        return selected
          ? {
              ...user,
              ...selected,
            }
          : user;
      });

      let data = {
        ...state,
        suppliers: {
          ...state.suppliers,
          approved: {
            ...state.supplier.approved,
            data: updatedSupplier,
          },
        },
      };
      console.log("yolo holo");
      return data;

    case UPDATE_UNAPPROVED_SUPPLIER:
      let supplier = state.suppliers.unapproved.data.map((user) => {
        return action.payload?.id === user.id
          ? {
              ...user,
              ...action.payload,
            }
          : user;
      });
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          unapproved: {
            ...state.supplier.unapproved,
            data: supplier,
          },
        },
      };

    case UPDATE_MULTIPLE_UNAPPROVED_SUPPLIERS:
      let suppliers = state.suppliers.unapproved.data.map((user) => {
        let selected = action.payload.find(
          (supplier) => supplier.id === user.id
        );

        return selected
          ? {
              ...user,
              ...selected,
            }
          : user;
      });
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          unapproved: suppliers,
        },
      };

    case UPDATE_SUPPLIER_LICENCE:
      let updated = state.suppliers.approved.data.map((user) => {
        return user.id === action.payload.id
          ? {
              ...user,
              ...action.payload.updatedLicence,
            }
          : user;
      });
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          approved: updated,
        },
      };

    case UPDATE_UNAPPROVED_SUPPLIER_LICENCE:
      let update_suppliers = state.suppliers.unapproved.data.map((user) => {
        return user.id === action.payload.id
          ? {
              ...user,
              ...action.payload.updatedLicence,
            }
          : user;
      });
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          unapproved: update_suppliers,
        },
      };

    case UPDATE_CUSTOMER_LICENCE:
      let updatedCustomers = state.customers.approved.data.map((user) => {
        return user.id === action.payload.id
          ? {
              ...user,
              ...action.payload,
            }
          : user;
      });
      return {
        ...state,
        customers: {
          ...state.customers,
          approved: {
            ...state.customer.approved,
            data: updatedCustomers
          },
        },
      };

    case DELETE_APPROVED_SUPPLIER:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          approved: {
            ...state.supplier.approved,
            data: state.suppliers.approved.data.filter(
              (user) => !action.payload.find((item) => item === user.id)
            ),
          },
        },
      };

    case RESTORE_USER_ACCOUNT:
      return {
        ...state,
        customers: {
          ...state.customers,
          deleted: {
            ...state.customers.deleted,
            data: state.customers.deleted.data.filter(
              (user) => !action.payload.find((item) => item === user.id)
            ),
          },
        },
      };

    case RESTORE_SUPPLIER_ACCOUNT:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          deleted: {
            ...state.suppliers.deleted,
            data: state.suppliers.deleted.data.filter(
              (user) => !action.payload.find((item) => item === user.id)
            ),
          },
        },
      };

    case DELETE_UNAPPROVED_SUPPLIER:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          unapproved: {
            ...state.supplier.unapproved,
            data: state.suppliers.unapproved.data.filter(
              (user) => !action.payload.find((item) => item === user.id)
            ),
          },
        },
      };

    case UPDATE_CUSTOMER:
      let updatedCustomer = state.customers.approved.data.map((user) => {
        return action.payload?.id === user.id
          ? {
              ...user,
              ...action.payload,
            }
          : user;
      });
      return {
        ...state,
        customers: {
          ...state.customers,
          approved: {
            ...state.customer.approved,
            data: updatedCustomer
          },
        },
      };

    case UPDATE_MULTIPLE_CUSTOMERS:
      let updated_customer = state.customers.approved.data.map((user) => {
        let selected = action.payload.find(
          (customer) => customer.id === user.id
        );

        return selected
          ? {
              ...user,
              ...selected,
            }
          : user;
      });
      return {
        ...state,
        customers: {
          ...state.customers,
          approved: {
            ...state.customers.approved,
            data: updated_customer,
          },
        },
      };

    case UPDATE_UNAPPROVED_CUSTOMER:
      let customer = state.customers.unapproved.data.map((user) => {
        return action.payload?.id === user.id
          ? {
              ...user,
              ...action.payload,
            }
          : user;
      });

      // return {
      //   ...state,
      //   customers: {
      //     ...state.customers,
      //     unapproved: customer,
      //   },
      // };

      return {
        ...state,
        customers: {
          ...state.customers,
          unapproved: {
            ...state.customers.unapproved,
            data: customer,
          },
        },
      };

    case UPDATE_MULTIPLE_UNAPPROVED_CUSTOMERS:
      let updateCustomer = state.customers.unapproved.data.map((user) => {
        let selected = action.payload.find(
          (customer) => customer.id === user.id
        );

        return user.id === selected
          ? {
              ...user,
              ...selected,
            }
          : user;
      });

      return {
        ...state,
        customers: {
          ...state.customers,
          unapproved: {
            ...state.customers.unapproved,
            data: updateCustomer,
          },
        },
      };

    case DELETE_APPROVED_CUSTOMER:
      return {
        ...state,
        customers: {
          ...state.customers,
          approved: {
            ...state.customers.approved,
            data: state.customers.approved.data.filter(
              (user) => !action.payload.find((item) => item === user.id)
            ),
          },
        },
      };

    case DELETE_UNAPPROVED_CUSTOMER:
      return {
        ...state,
        customers: {
          ...state.customers,
          unapproved: {
            ...state.customers.unapproved,
            data: state.customers.unapproved.data.filter(
              (user) => !action.payload.find((item) => item === user.id)
            ),
          },
        },
      };

    case REFUND:
      let updated_orders = state.orders.data.map((order) => {
        let selected = action.payload.id === order.id;

        let selected_order = {
          ...selected,
          ...{
            order_status: "Refunded",
            refund_status: 1,
          },
        };

        return selected
          ? {
              ...order,
              ...selected_order,
            }
          : order;
      });

      return {
        ...state,
        orders: {
          ...state.orders,
          data: updated_orders,
        },
      };

    case DELETE_PRODUCT:
      return {
        ...state,
        products: {
          ...state.customers,
          approved: state.customers.approved.filter(
            (user) => !action.payload.find((item) => item === user.id)
          ),
        },
      };

    case GET_CUSTOMER:
      return {
        ...state,
        customer: state.customers.approved.data.find(
          (i) => i.id === action.payload
        ),
      };

    case GET_UNAPPROVED_CUSTOMER:
      return {
        ...state,
        customer: state.customers.unapproved.data.find(
          (i) => i.id === action.payload
        ),
      };

    case ADD_CATEGORY:
      return {
        ...state,
        categories: [...state.categories, action.payload],
      };

    case ADD_SUPPLIER:
      return {
        ...state,
        suppliers: {
          ...state.suppliers,
          unapproved: [...state.suppliers.unapproved, action.payload],
        },
      };

    case ADD_CUSTOMER:
      return {
        ...state,
        customers: {
          ...state.customers,
          unapproved: [...state.customers.unapproved, action.payload],
        },
      };

    case PAUSE_SUPPLIER_SIGNUP:
      return {
        ...state,
        supplierSignup: false,
      };

    case RESUME_SUPPLIER_SIGNUP:
      return {
        ...state,
        supplierSignup: true,
      };

    case PAUSE_USER_SIGNUP:
      return {
        ...state,
        userSignup: false,
      };

    case RESUME_USER_SIGNUP:
      return {
        ...state,
        userSignup: true,
      };

    case UPDATE_ADMIN_USERNAME:
      return {
        ...state,
        currentAdmin: action.payload,
      };

    case FETCH_ORDERS:
      return {
        ...state,
        orders: action.payload,
      };

    case FETCH_ORDERS_BY_SUPPLIER:
      return {
        ...state,
        supplier_orders: action.payload,
      };

    case FETCH_SUPPLIER_PAYMENTS:
      return {
        ...state,
        supplier_payments: action.payload,
      };

    case UPDATE_SUPPLIER_PAYMENTS:
      let updated_supplier_payment = state.supplier_payments.data.map(
        (user) => {
          return action.payload?.id === user.id
            ? {
                ...user,
                ...{ ...user, ...{ payment_status: action.payload?.status } },
              }
            : user;
        }
      );
      return {
        ...state,
        supplier_payments: {
          ...state.supplier_payments,
          data: updated_supplier_payment,
        },
      };

    case FETCH_SUPPLIER_PRODUCTS:
      return {
        ...state,
        supplier_products: action.payload,
      };

    case FETCH_SUPPLIER_REPORTS:
      return {
        ...state,
        supplier_reports: action.payload,
      };

    case FETCH_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
      };

    case FETCH_SELECTED_SUPPLIERS:
      return {
        ...state,
        selectedSuppliers: action.payload,
      };

    case FETCH_ORDER:
      return {
        ...state,
        order: action.payload,
      };

    case PAUSE_SUPPLIER_CALL_REQUEST:
      return {
        ...state,
        supplierCallRequest: false,
      };

    case RESUME_SUPPLIER_CALL_REQUEST:
      return {
        ...state,
        supplierCallRequest: true,
      };

    case PAUSE_CUSTOMER_CALL_REQUEST:
      return {
        ...state,
        customerCallRequest: false,
      };

    case RESUME_CUSTOMER_CALL_REQUEST:
      return {
        ...state,
        customerCallRequest: true,
      };

    case CALL_SUPPLIER_REQUESTS:
      return {
        ...state,
        callRequests: {
          ...state.callRequests,
          supplier: action.payload,
        },
      };

    case CALL_USER_REQUESTS:
      return {
        ...state,
        callRequests: {
          ...state.callRequests,
          user: action.payload,
        },
      };

    case FETCH_SUPPLIER_FAQ:
      return {
        ...state,
        faqs: {
          ...state.faqs,
          supplier: action.payload,
        },
      };

    case FETCH_CUSTOMER_FAQ:
      return {
        ...state,
        faqs: {
          ...state.faqs,
          customer: action.payload,
        },
      };

    case CREATE_SUPPLIER_FAQ:
      return {
        ...state,
        faqs: {
          ...state.faqs,
          supplier: [...state.faqs.supplier, action.payload],
        },
      };

    case CREATE_USER_FAQ:
      return {
        ...state,
        faqs: {
          ...state.faqs,
          customer: [...state.faqs.customer, action.payload],
        },
      };

    case UPDATE_SUPPLIER_FAQ:
      let supplierFaq = state.faqs.supplier.map((item) => {
        return item.id === action.payload.id
          ? {
              ...item,
              ...action.payload,
            }
          : item;
      });
      return {
        ...state,
        faqs: {
          ...state.faqs,
          supplier: supplierFaq,
        },
      };

    case UPDATE_USER_FAQ:
      let userFaq = state.faqs.customer.map((item) => {
        return item.id === action.payload.id
          ? {
              ...item,
              ...action.payload,
            }
          : item;
      });
      return {
        ...state,
        faqs: {
          ...state.faqs,
          customer: userFaq,
        },
      };

    case DELETE_SUPPLIER_FAQ:
      return {
        ...state,
        faqs: {
          ...state.faqs,
          supplier: state.faqs.supplier.filter(
            (faq) => !action.payload.find((item) => item === faq.id)
          ),
        },
      };

    case DELETE_USER_FAQ:
      return {
        ...state,
        faqs: {
          ...state.faqs,
          customer: state.faqs.customer.filter(
            (faq) => !action.payload.find((item) => item === faq.id)
          ),
        },
      };

    case DELETE_CALL_USER_REQUEST:
      return {
        ...state,
        callRequests: {
          ...state.callRequests,
          user: state.callRequests.user
            .filter
            // (request) => request.id !== action.payload
            (),
        },
      };

    case DELETE_CALL_SUPPLIER_REQUEST:
      return {
        ...state,
        callRequests: {
          ...state.callRequests,
          supplier: state.callRequests.supplier
            .filter
            // (request) => request.id !== action.payload
            (),
        },
      };

    default:
      return {
        ...state,
      };
  }
};

export default adminReducer;
